export default "__VITE_ASSET__tPaZqo1t__"